import { apiCall } from './gqlClient';

const GETALLEMAILTEMPLATES_QUERY = `
  query getAllEmailTemplates {
    getAllEmailTemplates
    {
      id
			providerId
			fileId
			thumbnailUrl
			fileName
			fileTitle
			name
			header
			content
			footer
			color
			active
      ...fragments
    }
  }`;

export const getAllEmailTemplatesApiCall = async (fragments = null) => apiCall({ query: GETALLEMAILTEMPLATES_QUERY, variables: {}, fragments });

const SAVEEMAILTEMPLATE_QUERY = `
  mutation saveEmailTemplate($template: EmailTemplateInput!) {
    saveEmailTemplate(template: $template)
    {
      id
			copyId
			presignedUrl
			presignedUrls
			signedUrl
			success
			name
			sectionIndex
			type
			signatureFileId
      ...fragments
    }
  }`;

export const saveEmailTemplateApiCall = async ({template}, fragments = null) => apiCall({ query: SAVEEMAILTEMPLATE_QUERY, variables: {template}, fragments });

const UPDATEEMAILTEMPLATE_QUERY = `
  mutation updateEmailTemplate($id: String!, $template: EmailTemplateInput!) {
    updateEmailTemplate(id: $id, template: $template)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const updateEmailTemplateApiCall = async ({id, template}, fragments = null) => apiCall({ query: UPDATEEMAILTEMPLATE_QUERY, variables: {id, template}, fragments });

const DELETEEMAILTEMPLATE_QUERY = `
  mutation deleteEmailTemplate($id: String!, $active: Boolean!) {
    deleteEmailTemplate(id: $id, active: $active)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const deleteEmailTemplateApiCall = async ({id, active}, fragments = null) => apiCall({ query: DELETEEMAILTEMPLATE_QUERY, variables: {id, active}, fragments });

const ACTIVATEEMAILTEMPLATE_QUERY = `
  mutation activateEmailTemplate($id: String!, $color: String!, $logo: String!, $active: Boolean!) {
    activateEmailTemplate(id: $id, color: $color, logo: $logo, active: $active)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const activateEmailTemplateApiCall = async ({id, color, logo, active}, fragments = null) => apiCall({ query: ACTIVATEEMAILTEMPLATE_QUERY, variables: {id, color, logo, active}, fragments });

const SENDTESTTEMPLATEMAIL_QUERY = `
  mutation sendTestTemplateMail {
    sendTestTemplateMail
  }`;

export const sendTestTemplateMailApiCall = async () => apiCall({ query: SENDTESTTEMPLATEMAIL_QUERY, variables: {}});
